import { render, staticRenderFns } from "./DocRate.vue?vue&type=template&id=cc41fafc&scoped=true&"
import script from "./DocRate.vue?vue&type=script&lang=js&"
export * from "./DocRate.vue?vue&type=script&lang=js&"
import style0 from "./DocRate.vue?vue&type=style&index=0&id=cc41fafc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc41fafc",
  null
  
)

export default component.exports